const driverShifts = {
  driverShifts: 'משמרות נהגים',

  driverLink: 'קישור לאפליקציית לוח הזמנים של הנהג',

  filters: {
    areas: 'אזורים',
    drivers: 'נהגים',
    suppliers: 'ספקים',
    vehicles: 'רכבים',
    locations: 'מיקומים',
    airportLocations: 'מיקומי שדה תעופה',
    attributes: 'מאפיינים',
  },

  calendarTypes: {
    daily: 'יומי',
    weekly: 'שבועי',
    monthly: 'חודשי',
  },

  driverfilter: {
    all: 'כל הנהגים',
    withShift: 'נהגים עם משמרות',
    withoutShifts: 'נהגים ללא משמרות',
  },

  header: {
    create: 'הוסף',
    createMulti: 'הוסף רשומות מרובות',
    import: 'ייבא',
    switchButton: {
      label: 'תצוגה',
      table: 'טבלה',
      calendar: 'לוח שנה',
    },
  },

  moreActions: {
    delete: 'מחק',
  },
  toast: {
    error: {
      sameDate: 'תאריך התחלה ותאריך סיום לא יכולים להיות זהים',
      badResponse: '[משמרות נהגים] תגובת שרת שגויה',
      create: {},
      edit: {},
    },
    success: {
      create: {},
      edit: {},
    },
  },
  headerButtons: {
    createBtn: 'הוסף',
    createMultiBtn: 'הוסף משמרות מרובות',
    deleteBtn: 'מחק',
  },

  table: {
    actions: {
      delete: 'מחק',
      export: 'ייצא',
    },
    headers: {
      name: 'נהג',
      email: 'נהג',
      address: 'כתובת',
      firstTripDistance: 'מרחק מקסימלי לנסיעה ראשונה',
      addrLon: 'קו אורך',
      addrLat: 'קו רוחב',
      at: 'נוצר בתאריך',
      by: 'נוצר על ידי',
      areas: 'אזורים',
      locations: 'מיקומים',
      attributes: 'מאפיינים',
    },
    cells: {
      name: {
        vehicle: 'רכב',
      },
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },

  create: {
    successToast: {
      message: 'הצלחה! משמרת נהג נוצרה!',
    },
    errorToast: {
      message: 'אירעה שגיאה! לא ניתן ליצור משמרת נהג',
    },

    multi: {
      successToast: {
        message: 'הצלחה! משמרות נהגים נוצרו!',
      },
      errorToast: {
        message: 'שגיאה! בחר יום חול תקין למשמרת הנהג',
      },
    },
    modalAfter24: {
      header: 'אזהרה',
      body: 'לא ניתן לשנות משמרות שעברו כבר 24 שעות',
    },
    modalBefore24: {
      header: 'אזהרה',
      body: 'שינויים שנעשו בתוך 24 שעות ממשמרת קיימת דורשים אישור. אנא אשר כדי להמשיך',
    },
  },

  update: {
    successToast: {
      message: '{{count}} משמרות נהג עודכנו בהצלחה',
    },
    errorToast: {
      message: 'אירעה שגיאה! לא ניתן לעדכן משמרת נהג',
    },

    scopeModal: {
      title: 'עדכון משמרת',
      body: 'האם להחיל את השינויים על:',
      options: {
        single: 'משמרת זו בלבד',
        thisAndFuture: 'משמרת זו וכל המשמרות העתידיות',
        allEvents: 'כל המשמרות',
        allEventsSubtitle: 'לא כולל משמרות שעברו',
      },
      update: 'עדכון',
      cancel: 'ביטול',
    },
  },

  import: {
    title: 'העלאת משמרות נהגים',
  },

  delete: {
    scopeModal: {
      title: 'מחיקת משמרת',
      body: 'אילו משמרות ברצונך למחוק?',
      confirm: 'מחק',
    },
    modalError: {
      header: 'אירעה שגיאה',
      body: 'לא ניתן לעדכן',
    },
    modalSuccess: {
      header: 'הצלחה',
      body: ' - Shifts deleted successfully',
    },
  },

  modalRemoveConfirm: {
    header: 'אזהרה!',
    bodySingle: 'האם אתה בטוח שברצונך למחוק משמרת זו?',
    bodyMultiple: 'האם אתה בטוח שברצונך למחוק משמרות אלה?',
    confirmBtn: 'מחק',
  },

  modalRemoveSingelConfirm: {
    header: 'מחק משמרת נהג',
    body: 'אתה עומד למחוק משמרת נהג אחת',
  },

  form: {
    header: {
      createDriverShift: {
        title: 'הוסף',
      },

      createMultipleDriverShift: {
        title: 'הוסף רשומות מרובות',
      },

      updateDriverShift: {
        title: 'עדכן',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'שמור',
        update: 'שמור',
        delete: 'מחק',
      },
    },

    information: {
      details: {
        header: 'פרטי נהג',
        fields: {
          driver: 'נהג',
          vehicle: '{{currentVehicle}} :רכב',
        },
      },
      shiftDetails: {
        header: 'פרטי משמרת',
        overnightShiftNote: 'הערה: זו משמרת לילה',
        multiDriverTimezoneNote: 'הערה: הזמנים יפורשו באזור הזמן המקומי של כל נהג נבחר',
        shiftDurationNote: 'הערה: משמרת לא יכולה להיות ארוכה מ-24 שעות',
        fields: {
          fromDate: 'התחלה',
          toDate: 'סיום',
          template: 'תבנית משמרת',
          address: 'כתובת',
          firstTripDistance: 'מרחק מקסימלי לנסיעה ראשונה',
          attributes: 'מאפיינים',
          areas: 'אזורים',
          areasPriorityMode: {
            title: 'מצב',
            options: {
              allStops: 'כל התחנות',
              firstPickDrop: 'איסוף ראשון / הורדה אחרונה',
              legAOrigin: 'A מוצא מקטע',
            },
          },
          areasPriorityLevel: {
            title: 'עדיפות',
            options: {
              low: 'נמך',
              medium: 'בינוני',
              high: 'גבוה',
              strict: 'קפדני',
            },
          },
          vehicle: 'רכב נוכחי',
          suppliers: 'ספקים',
          allowSharedRides: 'אפשר נסיעות משותפות',
          ignoreDropoffTime: 'התעלם מזמן הורדה',
          ignoreDropoffTimeOptions: {
            byDriverSettings: 'לפי הגדרות נהג',
            enabled: 'מופעל',
            disabled: 'כבוי',
          },
          shiftBuffer: 'באפר משמרת',
        },
      },
      locationsSettings: {
        header: 'הגדרות מיקומים',
        fields: {
          locations: 'מיקומים',
          enableInBetweenRides: 'אפשר נסיעות ביניים',
        },
      },
    },
    validations: {
      drivers: {
        required: 'נדרשים נהגים',
        drivers: '',
      },
      driver: {
        required: 'נהג נדרש',
        driver: '',
      },
      start: {
        required: 'שעת התחלה נדרשת',
        start: '',
      },
      end: {
        required: 'שעת סיום נדרשת',
        endMustBeAfterStart: 'שעת הסיום של המשמרת חייבת להיות לאחר שעת ההתחלה.',
        end: '',
      },
      breakOutsideShift: 'ההפסקות חייבות להיות בתוך שעות המשמרת',
    },
    select: 'בחר',
    buttons: {
      addBreak: 'הוסף הפסקה +',
    },
  },

  formMulti: {
    header: {
      createMultiDriverShift: {
        title: 'משמרות מרובות נהגים חדשות',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'שמור',
        update: 'ערוך משמרות מרובות נהגים',
      },
    },

    information: {
      details: {
        header: 'פרטי נהג',
        fields: {
          drivers: 'נהגים',
        },
      },
      shiftDetails: {
        header: 'פרטי משמרת',
        fields: {
          fromDate: 'מתאריך',
          toDate: 'עד תאריך',
          weeksDays: 'ימי השבוע',
          fromHour: 'משעה',
          tohour: 'עד שעה',
          breakStart: 'התחלת הפסקה',
          breakEnd: 'סיום הפסקה',
        },
      },
    },
    validations: {
      drivers: {
        required: 'נדרשים נהגים',
      },
      driver: {
        required: 'נהג נדרש',
      },
      start: {
        required: 'שעת התחלה נדרשת',
      },
      end: {
        required: 'שעת סיום נדרשת',
      },
    },
    select: 'בחר',
  },

  totalDriverShifts: 'סה"כ משמרות נהג',

  calendarTable: {
    filters: {
      areas: 'אזורים',
      drivers: 'נהגים',
      suppliers: 'ספקים',
      attributes: 'מאפיינים',
    },

    daily: {
      actions: {
        delete: 'מחק',
        deleteTooltip: 'היום הנוכחי של הנהג אינו כולל משמרות',
      },
      noResults: 'לא נמצאו תוצאות',
      noResultsSubHeader: 'לא הצלחנו למצוא פריט התואם את החיפוש שלך',
      selectAll: 'בחר הכל',
      selectAllPages: 'All {{limit}} items on this page are selected. ',
      btnSelectAllResults: ' Select all {{totalDrivers}} items',
      btnunselectAllResults: 'נקה בחירה',
      totalDrivers: 'סה"כ נהגים: {{total}}',
      totalShifts: 'סה"כ משמרות: {{total}}',
    },
    weekly: {
      actions: {
        delete: 'מחק',
      },
    },
    emptyCell: {
      dayOff: 'יום חופשי',
    },
    headers: {
      driverName: 'שם',
      monday: 'יום שני {{day}}',
      tuesday: 'יום שלישי {{day}}',
      wednesday: 'יום רביעי {{day}}',
      thursday: 'יום חמישי {{day}}',
      friday: 'יום שישי {{day}}',
      saturday: 'יום שבת {{day}}',
      sunday: 'יום ראשון {{day}}',
    },
  },
};

export default driverShifts;
